import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { LocalStorageService } from '../../../../core/services/localStorage/local-storage.service';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
import { resolveNotesRule } from '../../../../core/utils/form.utils';
import { NgSelectModule } from '@ng-select/ng-select';
interface AccountData {
  reference: string;
  lastname: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}

@Component({
  selector: 'app-general-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    NgSelectModule,
  ],
  templateUrl: './general-form.component.html',
  styleUrl: './general-form.component.css'
})
export class GeneralFormComponent {
  @Input() invoiceData?: any;
  @Input() ladata: any = [];
  @Output() emitSubmit = new EventEmitter<string>();

  account_type = this.authStateService.getAccountType();
  generalForm: FormGroup = new FormGroup({});

  draft = false;
  order_reference: string = '';
  stage?: any;
  newStage: string = '';

  role: any;

  back = "";
  next_ok = "";
  next_ko = "";

  agentData: AccountData[] = [];
  dealershipData: AccountData[] = [];
  organizationData: AccountData[] = [];
  supplierData: AccountData[] = [];
  stages: { key: string }[] = [];

  constructor(private fb: FormBuilder, private alertService: AlertService, private localStorageService: LocalStorageService, private authStateService: AuthStateService) {
    this.generalForm = this.fb.group({
      organization_id: ['', Validators.required],
      dealership_id: ['', Validators.required],
      invoiced_at: ['', Validators.required],
      paid_at: ['', Validators.required],
      serial: ['', Validators.required],
      number: ['', Validators.required],
      notes: ['', Validators.required],
      stage: ['draft', Validators.required],
    });
  }

  ngOnInit(): void {
    this.check_selects_length();
  }

  ngAfterViewInit() {

  }

  checkUpdateForm(): boolean {
    if (this.generalForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        this.role = this.authStateService.getRole();
        this.dealershipData = this.ladata.dealershipData;
        this.organizationData = this.ladata.organization;


        if (this.invoiceData) {
          this.refrescarFormulario();
        }
      }

      if (changes['invoiceData']) {
        if (this.invoiceData) {
          this.refrescarFormulario();
        }
      }
    }
  }

  changeStage(event: any) {
    this.newStage = event;
  }

  refrescarFormulario() {
    this.setVariables();
    this.updateFieldAccessibility();
    for (const key in this.invoiceData) {
      const control = this.generalForm.controls[key];
      const value = this.invoiceData[key];
      if (control) {
        control.setValue(value);
      }
      if (control) {
        switch (key) {
          case 'broker_agent_id':
            if (this.account_type === 'broker') {
              control.setValue(value);
            } else {
              const brokerAgentName = `${this.invoiceData?.broker_agent?.name || ''} ${this.invoiceData?.broker_agent?.lastname || ''}`.trim();
              this.generalForm.get('broker_agent')?.setValue(brokerAgentName);
              control.setValue(value);
            }
            break;
          case 'supplier_agent_id':
            if (this.account_type === 'supplier') {
              control.setValue(value);
            } else {
              const supplierAgentName = `${this.invoiceData?.supplier_agent?.name || ''} ${this.invoiceData?.supplier_agent?.lastname || ''}`.trim();
              this.generalForm.get('supplier_agent')?.setValue(supplierAgentName);
              control.setValue(value);
            }
            break;
          case 'notes':
            this.generalForm.get('notes')?.setValue("");
            break;
          default:
            control.setValue(value);
            break;
        }
      }


    }
    this.alertService.close();
  }
  updateFieldAccessibility() {
    var rules = resolveNotesRule(this.invoiceData?.rules, 'public') as Record<string, any>;
    // Deshabilitar todos los campos por defecto
    for (const field in this.generalForm.controls) {
      if (this.generalForm.controls.hasOwnProperty(field)) {
        this.generalForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.generalForm.get(field)?.enable();
      }
    }

  }

  onSubmitOrderFast(stage: string) {
    this.emitSubmit.emit(stage);
  }

  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }
  check_selects_length() {
    if (this.organizationData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ organization_id: this.organizationData[0].reference });
    }
    if (this.dealershipData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ dealership_id: this.dealershipData[0].reference });
    }
  }

  setVariables() {
    this.back = this.invoiceData?.back || '';
    this.next_ok = this.invoiceData?.next_ok;
    this.next_ko = this.invoiceData?.next_ko;
    this.stage = this.invoiceData?.stage;
    this.draft = this.invoiceData ? true : false;
    this.order_reference = this.invoiceData?.reference;
    const allStageKeys: string[] = [
      ...(this.invoiceData?.stage ? [this.invoiceData.stage] : []),
      ...((this.invoiceData?.stages || []).filter((s: string) => s !== this.invoiceData?.stage)),
    ];
    this.stages = allStageKeys.map((key: string) => ({ key }));
  }
}
